import { UnrealisedAssetFXGainOrLossType } from 'further-types/lp/unrealised-asset-fx-gain-or-loss';
import {
  UnrealisedCashFXGainOrLossActionType,
  UnrealisedCashFXGainOrLossType,
} from 'further-types/lp/unrealised-cash-fx-gain-or-loss';
import { UnrealisedFXGainOrLossSubType } from 'further-types/lp/unrealised-fx-gain-or-loss';

export const UnrealisedCashFXGainOrLossActionTypeLabels = {
  [UnrealisedCashFXGainOrLossActionType.UnrealisedCashFXGainOrLossCreated]:
    'Unrealised Cash FX Gain or Loss ',
};

export const UnrealisedCashFXGainOrLossTypeLabels = {
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXGain]:
    'Unrealised Cash FX Gain',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXLoss]:
    'Unrealised Cash FX Loss',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXUnwindGain]:
    'Unrealised Cash FX Unwind Gain',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXUnwindLoss]:
    'Unrealised Cash FX Unwind Loss',
};

export const UnrealisedFXGainOrLossSubTypeLabels = {
  [UnrealisedFXGainOrLossSubType.FXGainPayable]: 'FX Gain (Payable)',
  [UnrealisedFXGainOrLossSubType.FXLossPayable]: 'FX Loss (Payable)',
  [UnrealisedFXGainOrLossSubType.FXGainReceivable]: 'FX Gain (Receivable)',
  [UnrealisedFXGainOrLossSubType.FXLossReceivable]: 'FX Loss (Receivable)',
};

export const UnrealisedAssetFXGainOrLossTypeLabels = {
  [UnrealisedAssetFXGainOrLossType.UnrealisedAssetFXGain]:
    'Unrealised Investment FX Gain (Unrealised Investment FX Gain)',
  [UnrealisedAssetFXGainOrLossType.UnrealisedAssetFXLoss]:
    'Unrealised Investment FX Loss (Unrealised Investment FX Loss)',
};
